import { IQueryParams } from '../../types/type';

// Поля поиска GET /profiles (epl_backend GetAllProfilesHandler): подстрока без учёта регистра.
// Отчества и ФИО целиком бэкенд не ищет.
export const USER_SEARCH_FIELDS = ['lastName', 'firstName', 'phone', 'login'] as const;

export type UserSearchField = (typeof USER_SEARCH_FIELDS)[number];

export interface IUserSearch {
  field: UserSearchField;
  query: string;
}

export const DEFAULT_USER_SEARCH_FIELD: UserSearchField = 'lastName';

const USER_SEARCH_LABELS: Record<UserSearchField, string> = {
  lastName: 'Фамилия',
  firstName: 'Имя',
  phone: 'Телефон',
  login: 'Логин',
};

// Пункты выпадающего списка поиска в шапке
export const USER_SEARCH_OPTIONS: IQueryParams[] = USER_SEARCH_FIELDS.map((field) => ({
  i_id: `user-search-${field}`,
  i_name: 'userSearch',
  i_type: 'radio',
  i_value: field,
  i_label: USER_SEARCH_LABELS[field],
}));

export function isUserSearchField(value: string): value is UserSearchField {
  return (USER_SEARCH_FIELDS as readonly string[]).includes(value);
}

// Телефон хранится цифрами: «+7 (999) 12» ищем как «799912»
const searchText = ({ field, query }: IUserSearch): string =>
  field === 'phone' ? query.replace(/\D/g, '') : query.trim();

// Параметр запроса для поиска; пустой поиск не отправляем
export function userSearchParams(search: IUserSearch): Partial<Record<UserSearchField, string>> {
  const text = searchText(search);
  return text ? { [search.field]: text } : {};
}
